import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query'
import type { IReviewTopic, IReviewTopicPayload } from '~/types/review'

import {
  createReviewTopic,
  deleteReviewTopic,
  getReviewsTopics,
  getReviewsTopicsCategories,
  updateReviewTopic,
} from '~/api/reviews'

////////// KEYS //////////

export const keys = {
  all: ['reviews-topics'] as const,
  categories: () => [...keys.all, 'categories'] as const,
  details: (id: string) => [...keys.all, id] as const,
  list: () => [...keys.all, 'listing'] as const,
}

////////// QUERIES //////////

export const useReviewsTopicsQuery = (): UseQueryResult<IReviewTopic[]> => {
  return useQuery({ queryFn: getReviewsTopics, queryKey: keys.list() })
}

export const useReviewsTopicsCategoriesQuery = (): UseQueryResult<string[]> => {
  return useQuery({
    queryFn: getReviewsTopicsCategories,
    queryKey: keys.categories(),
  })
}

////////MUTATION //////////

export const useCreateReviewTopicMutation = (): UseMutationResult<
  IReviewTopic,
  unknown,
  IReviewTopicPayload,
  unknown
> => {
  return useMutation({ mutationFn: createReviewTopic })
}

export const useDeleteReviewTopicMutation = (): UseMutationResult<void, unknown, { topicId: string }, unknown> => {
  return useMutation({ mutationFn: deleteReviewTopic })
}

export const useUpdateReviewTopicMutation = (): UseMutationResult<
  IReviewTopic,
  unknown,
  { payload: IReviewTopicPayload; topicId: string },
  unknown
> => {
  return useMutation({ mutationFn: updateReviewTopic })
}
